import { Paper } from '@mantine/core';
import './styling.css';
import { type ReactNode } from 'react';
import { subPath } from '@/subpath.config'

interface Props {
  children?: ReactNode;
}

export const PreAuth = (props: Props): JSX.Element => {
  const prosazLogoSvgPath = `${subPath}/prosazLogo.svg`
  return (
    <div className="!min-h-screen !w-full bg-gray-100 flex justify-center items-center">
      <Paper
        shadow="sm"
        radius="md"
        maw="50rem"
        mih="25rem"
        withBorder
        className="w-full bg-white h-auto relative p-4 pt-24 m-4 mt-24 flex justify-center"
      >
        <div className="box-logo-login">
          <img className="logo-login" src={prosazLogoSvgPath} alt="prosaz Logo" />
        </div>

        {props.children}
      </Paper>
    </div>
  );
};
